import { CATEGORY_TYPE } from 'models/documents.model';

import { ReactComponent as BatteryPack } from '../assets/category/battery-pack.svg';
import { ReactComponent as BatteryIcon } from '../assets/category/battery.svg';
import { ReactComponent as ConstructionIcon } from '../assets/category/construction.svg';
import { ReactComponent as EarthIcon } from '../assets/category/earth.svg';
import { ReactComponent as PreviewIcon } from '../assets/category/preview.svg';
import { ReactComponent as RecycleIcon } from '../assets/category/recycle.svg';
import { ReactComponent as ScienceIcon } from '../assets/category/science.svg';
import { ReactComponent as ThrashIcon } from '../assets/category/trash.svg';

export const categoryIconMapping = [
  {
    category: CATEGORY_TYPE.CHEMISTRY,
    Icon: ScienceIcon,
  },
  {
    category: CATEGORY_TYPE.BATTERY_CELLS,
    Icon: BatteryIcon,
  },
  {
    category: CATEGORY_TYPE.BATTERY_PACKS,
    Icon: BatteryPack,
  },
  {
    category: CATEGORY_TYPE.BATTERY_TECH_REVIEW,
    Icon: PreviewIcon,
  },
  {
    category: CATEGORY_TYPE.BATTERY_PACKS_REPAIR,
    Icon: ConstructionIcon,
  },
  {
    category: CATEGORY_TYPE.BATTERY_REPURPOSE,
    Icon: RecycleIcon,
  },
  {
    category: CATEGORY_TYPE.BATTERY_PACKS_RECYCLING,
    Icon: EarthIcon,
  },
  {
    category: CATEGORY_TYPE.BATTERY_WASTE,
    Icon: ThrashIcon,
  },
];

export const getIconByCategory = (category: CATEGORY_TYPE) =>
  categoryIconMapping.find((i) => i.category === category);
